<template>
  <div class="surface-0 shadow-2 px-3 py-2 flex align-items-center justify-content-between navbar">
    <div class="flex align-items-center">
      <img src="@/assets/ask-bookmaker.svg" alt="logo" class="w-6" />
    </div>

    <Button icon="pi pi-bars" class="p-button-text p-button-plain md:hidden" @click="toggleMenu" />

    <div class="hidden md:flex align-items-center gap-3">
      <RouterLink to="/">
        <Button label="Home" icon="pi pi-home" class="p-button-text" />
      </RouterLink>
      <!--      <RouterLink to="/contact">-->
      <!--        <Button label="Contact" icon="pi pi-envelope" class="p-button-text" />-->
      <!--      </RouterLink>-->
      <Button
        label="Start&nbsp;Building"
        icon="pi pi-play"
        class="p-button-rounded p-button-primary"
        @click="openApp"
      />
    </div>

    <Sidebar v-model:visible="menuOpen" position="right" class="w-14rem">
      <div class="flex flex-column gap-1">
        <RouterLink to="/">
          <Button label="Home" icon="pi pi-home" class="p-button-text" />
        </RouterLink>
        <!--        <RouterLink to="/contact">-->
        <!--          <Button label="Contact" icon="pi pi-envelope" class="p-button-text" />-->
        <!--        </RouterLink>-->
        <Button label="Start" icon="pi pi-play" class="mt-3 w-full" @click="openApp" />
      </div>
    </Sidebar>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Button from 'primevue/button'
import Sidebar from 'primevue/sidebar'
import { useRoute } from 'vue-router'

const menuOpen = ref<boolean>(false)

const toggleMenu = (): void => {
  menuOpen.value = true
}

const route = useRoute()

watch(
  () => route.fullPath,
  () => {
    menuOpen.value = false
  },
)

function openApp() {
  window.location.href = window.__APP_CONFIG__.APP_START_URL
}
</script>

<style scoped>
.navbar {
  width: 100vw;
  position: sticky;
  top: 0;
  z-index: 1000;
}

a:hover {
  cursor: pointer;
}
</style>
